import styled from 'styled-components'
import { deviceMax } from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import SelectComponent from '../Select/Select'

export const SelectContainer = styled.div`
  z-index: 5;
  position: relative;
  align-items: center;
  display: flex;
  border-radius: ${pxToRem(5)};
  margin-right: ${pxToRem(20)};
  @media ${deviceMax.mobileL} {
    margin-right: initial;
    margin-bottom: ${pxToRem(20)};
    width: 100%;
  }
`

export const StyledPrefix = styled.p`
  justify-content: center;
  align-items: center;
  display: flex;
  padding-left: ${pxToRem(10)};
  border-radius: ${pxToRem(5)} 0 0 ${pxToRem(5)};
  height: ${pxToRem(40)};
  background-color: ${({ theme }) => theme.colors.secondary.grey95};
`

export const StyledSelect = styled(SelectComponent)`
  flex: 1;
  width: 100%;
  border: none;

  .react-select__option--is-focused {
    background-color: ${({ theme }) => theme.colors.main.grayLight};
  }

  .react-select__option--is-selected {
    background-color: ${({ theme }) => theme.colors.custom.blueLight};
  }

  .react-select__control {
    box-shadow: none;
    background-color: ${({ theme }) => theme.colors.secondary.grey95};
    border-width: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: ${pxToRem(2)} 0;
    border-radius: 0 ${pxToRem(5)} ${pxToRem(5)} 0;
  }
`
